import { getProductCardData } from '@yme/utils/product';
export function isProductCardsSectionEmpty(props) {
    return !props.header || !props.plpPagePath;
}
export function getPreparedCardsData({ data, pdpPageUrl, isInAuthor, }) {
    const result = data.map((product) => {
        const { name, images, sku, embargoExternal, type, popularityIndex, prices, stock, isStock, cardUrl, } = getProductCardData({
            itemData: product,
            path: pdpPageUrl,
            isInAuthor,
            isImageMasterVariant: false,
            isCheapestVariant: true,
        });
        return {
            id: product.id,
            name,
            prices,
            images,
            embargoExternal,
            popularityIndex,
            stock,
            sku,
            isStock,
            cardUrl,
            type,
        };
    });
    return result;
}
